import { V2SocketEvents } from '@flipster/r230522/original/socket';
import Socket from '@flipster/socket/Socket';
import SocketPingPongPlugin from '@flipster/socket/SocketPingPongPlugin';
import { CookieKeys, cookieStore } from '@flipster/utils/cookie';
import { getServerHostname } from '@flipster/utils/env-helper';

const getCurrentNuts = () => cookieStore.get(CookieKeys.Nuts);

// Webview 빌드시에 page prerendering이 되면서 `getServerHostname`이 빈 문자열을 반환할 수 있음.
// URL 생성자에 들어가는 인자는 올바른 URL이어야 함.
// 실제로 사용되지는 않으므로 invalid를 사용.
const baseUrl = new URL(getServerHostname() || 'http:invalid');
baseUrl.protocol = baseUrl.protocol === 'http:' ? 'ws:' : 'wss:';

export function createPublicNormalSub230522Socket() {
  const publicSubscriptionR230522Url = new URL('/api/v2/stream/r230522-public?mode=subscription', baseUrl);
  return new Socket<V2SocketEvents>(
    publicSubscriptionR230522Url,
    'r230522-subscription-public',
    [SocketPingPongPlugin()],
    { getSessionId: getCurrentNuts },
  );
}

export function createPrivateNormalSub230522Socket() {
  const privateSubscriptionR230522Url = new URL('/api/v2/stream/r230522?mode=subscription', baseUrl);
  return new Socket<V2SocketEvents>(
    privateSubscriptionR230522Url,
    'r230522-subscription-private',
    [SocketPingPongPlugin({ trackRtt: true })],
    { getSessionId: getCurrentNuts },
  );
}
